import configureRaven from 'raven-hubspot/configure';
import { configureLogFetchErrors as completeConfigureErrors } from 'quartz/internal/configure-logfetch-errors';
export function configureLogfetchErrors(config) {
  completeConfigureErrors(configureRaven, config);
}